export var categoryArtistOrTour = {
  1: {
    idKey: 'celebrityId',
    nameKey: 'celebrityName',
    headKey: 'headUrl',
    schemaUrl: 'celebritySchemaUrl'
  },
  2: {
    idKey: 'dramaId',
    nameKey: 'dramaName',
    headKey: 'dramaLogoUrl',
    schemaUrl: 'dramaSchemaUrl'
  }
};